import { HttpMethods } from '../enums/HttpMethods';
import { DataWrapper } from '../interfaces/DataWrapper';
import { PostPreference } from '../interfaces/PostPreference';
import { Preference } from '../interfaces/Preference';
import { UserPreference } from '../interfaces/UserPreference';
import ContentFeedService from './contentFeed.service';

class PreferencesService {
  public static getAll(): Promise<Preference[]> {
    return ContentFeedService.sendRequest<void>(HttpMethods.GET, 'preferences/?populate=*')
      .then((data: DataWrapper<any>) => data.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getByID(id: number): Promise<Preference> {
    return ContentFeedService.sendRequest<void>(HttpMethods.GET, `preferences/${id}/?populate=*`)
      .then((wrappedPreference: DataWrapper<Preference>) => wrappedPreference.data)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static getByUserEmail(email: string): Promise<UserPreference[]> {
    return ContentFeedService.sendRequest<void>(HttpMethods.GET, `preferences/user-email/${email}`)
      .then((preferences: UserPreference[]) => preferences)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static create(preference: DataWrapper<PostPreference>): Promise<number> {
    return ContentFeedService.sendRequest<DataWrapper<PostPreference>>(HttpMethods.POST, 'preferences', preference)
      .then((preference: Preference) => preference.id)
      .catch((error: Error) => {
        throw error;
      });
  }

  public static update(id: number, preference: DataWrapper<Partial<PostPreference>>): Promise<void> {
    return ContentFeedService.sendRequest<DataWrapper<Partial<PostPreference>>>(HttpMethods.PUT, `preferences/${id}`, preference)
    .catch((error: Error) => {
      throw error;
    });
  }

  public static delete(id: number): Promise<void> {
    return ContentFeedService.sendRequest<void>(HttpMethods.DELETE, `preferences/${id}`)
    .catch((error: Error) => {
      throw error;
    });
  }

  public static deleteAllByUserEmail(userEmail: string): Promise<void> {
    return ContentFeedService.sendRequest<void>(HttpMethods.DELETE, `preferences/delete-by-user-email/${userEmail}`)
    .catch((error: Error) => {
      throw error;
    });
  }
}

export default PreferencesService;
